import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class EnviosService extends ApiService {
  entityType = EntityType.ENVIO;
  url = 'api/envios/';
}
